<template>
  <div ref="histogram" class="histogramPanel"></div>
</template>
<script>
import * as echarts from "echarts";
import { debounce } from "lodash";
export default {
  name: "HistogramPanel",
  props: {
    yAxisData: {
      type: Array,
      required: true,
    },
    seriesData: {
      type: Array,
      required: true,
    },
  },
  watch: {
    yAxisData: {
      immediate: true,
      handler(newVal) {
        this.option.yAxis[0].data = newVal;
        if (newVal.length - 1 >= 4) {
          this.option.yAxis[0].max = 4;
        } else {
          this.option.yAxis[0].max = newVal.length - 1;
        }
        this.chartInstance?.setOption(this.option);
      },
    },
    seriesData: {
      immediate: true,
      handler(newVal) {
        this.option.series[0].data = newVal;
        this.chartInstance?.setOption(this.option);
      },
    },
    // 监听 option 变化并更新图表
    option: {
      handler(newOption) {
        this.chartInstance?.setOption(newOption);
      },
      deep: true,
    },
  },
  data() {
    return {
      myChart: null,
      chartInstance: null,
      option: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "5%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "value",
            splitLine: {
              lineStyle: {
                color: "#627489",
              },
            },
          },
        ],
        yAxis: [
          {
            data: this.yAxisData,
            inverse: true,
            animationDuration: 300,
            animationDurationUpdate: 300,
            // max: 3,
          },
        ],
        series: [
          {
            realtimeSort: true,
            name: this.$t("screen.orderNumber"),
            type: "bar",
            data: this.seriesData,
            barWidth: "40%",
            label: {
              show: true,
              position: "right",
              valueAnimation: true,
              color: "#ffffff",
            },
            textStyle: {
              color: "#ffffff",
            },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: "#188df022" }, // 渐变起始颜色
                { offset: 1, color: "#83bff6" }, // 渐变结束颜色
              ]),
            },
          },
        ],
        animationDuration: 0,
        animationDurationUpdate: 3000,
        animationEasing: "linear",
        animationEasingUpdate: "linear",
      },
    };
  },
  mounted() {
    this.initChart();
    window.addEventListener("resize", this.resizeChart);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeChart);
    this.chartInstance?.dispose();
  },
  methods: {
    initChart() {
      this.option.series[0].data = this.seriesData;
      if (!this.$refs.histogram) return;
      this.chartInstance = echarts.init(this.$refs.histogram);
      this.chartInstance.setOption(this.option);
      this.$emit("ready");
    },
    resizeChart: debounce(function () {
      this.chartInstance?.resize();
    }, 200),
  },
};
</script>
<style lang="scss" scoped>
@import "./style.scss";
</style>